import React from 'react'
import styled from 'react-emotion'
import { borderRadius, space, z } from '../../style'
import { StyledButton as Button } from '../common/Button'
import Text from 'common/components/Text'

const AlertOverlay = styled('div')({
  label: 'AlertOverlay',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(11, 11, 11, 0.7)',
  zIndex: z.alert
})
const AlertBox = styled('div')({
  label: 'Alert',

  // layout
  margin: '33vh auto 0',
  transform: 'translate(0, -50%)',

  // box
  width: 370,
  maxWidth: '94%',
  background: 'white',
  borderRadius,

  // content
  padding: space.default
})
const AlertActions = styled('div')({
  label: 'AlertActions',
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: space.default,

  [Button]: {
    borderRadius,
    marginLeft: space.small
  }
})

const Alert = ({ alert, dismiss }) => (
  <AlertOverlay onClick={alert.dismiss && dismiss}>
    <AlertBox onClick={e => e.stopPropagation()}>
      {alert.title && <Text bold>{alert.title}</Text>}
      {alert.message && <Text multiline>{alert.message}</Text>}
      <AlertActions>
        {alert.dismiss && <Button onClick={dismiss}>{alert.dismiss}</Button>}
        {alert.actions &&
          alert.actions.map((action, i) => (
            <Button
              primary={i === alert.actions.length - i}
              onClick={e => {
                if (action.dismiss !== false) dismiss()
                action.action(e)
              }}
              key={action.label}
            >
              {action.label}
            </Button>
          ))}
      </AlertActions>
    </AlertBox>
  </AlertOverlay>
)

export default Alert
